var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.50126 0L11.1279 5.26585L17 6.11059L12.7494 10.2093L13.7546 16L8.50126 13.2659L3.24796 16L4.25063 10.2093L0 6.11059L5.87461 5.26585L8.50126 0Z","fill":"#E7F8F4"}));
}

Star.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Star;

Star.default = Star;
